import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/Index'
import Diy from '@/pages/diy/Index' 
import Factory from '@/pages/factory/Index' 
import DiyCreate from '@/pages/orders/create/Index'   
import OrderCreate from '@/pages/orders/orderCreate/Index'   
import OrderSubmit from '@/pages/orders/submit/Index'  
import OrdersCart from '@/pages/orders/cart/Index'  
import OrdersAbandoned from '@/pages/orders/abandoned/Index'  
import UploadFiles from '@/pages/orders/UploadFiles' 
import Goods from '@/pages/goods/Index' 
import GoodsEdit from '@/pages/goods/Edit' 
import Goodsdetail from '@/pages/goods/Detail' 
import Orders from '@/pages/orders/Index' 
import Ordersdetail from '@/pages/orders/Detail' 
import Returns from '@/pages/returns/Index' 
import Visitor from '@/pages/orders/visitor/Index' 
import Customer from '@/pages/orders/customer/Index' 
import LogisticsIndex from '@/pages/logistics/Index'  
import LogisticsLabel from '@/pages/logistics/Label'  
import Activity from '@/pages/activity/Index'  
import Refund from '@/pages/refund/Index'
import Users from '@/pages/users/Index' 
import Usersdetail from '@/pages/users/Detail' 
import Sign from '@/pages/sign/Index' 
import SettingIndex from '@/pages/setting/Index' 
import Email from '@/pages/email/Index' 
import EmailTemplates from '@/pages/email/Templates' 
import EmailDetail from '@/pages/email/Detail'  
import TmpFont from '@/pages/tmp/Font'  


Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{requireAuth:true, title:'首页-OMS'},
    },
    {
      path: '/diy',
      name: 'Diy',
      component: Diy,
      meta:{requireAuth:true, title:'diy建模-OMS'},
    },
    {
      path: '/factory',
      name: 'Factory',
      component: Factory,
      meta:{requireAuth:true, title:'工厂生产-OMS'},
    },
    {
      path: '/goods',
      name: 'Goods',
      component: Goods,
      meta:{requireAuth:true, title:'商品-OMS'},
    },
    {
      path: '/goods/edit',
      name: 'GoodsEdit',
      component: GoodsEdit,
      meta:{requireAuth:true, title:'发布商品-OMS'},
    },
    {
      path: '/goods/detail',
      name: 'Goodsdetail',
      component: Goodsdetail,
      meta:{requireAuth:true, title:'商品详情-OMS'},
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      meta:{requireAuth:true, title:'订单-OMS'},
    },
    {
      path: '/orders/visitor',
      name: 'Visitor',
      component: Visitor,
      meta:{requireAuth:true, title:'订单-OMS'},
    },
    {
      path: '/orders/customer',
      name: 'Customer',
      component: Customer,
      meta:{requireAuth:true, title:'客户-OMS'},
    },
    {
      path: '/orders/detail',
      name: 'Ordersdetail',
      component: Ordersdetail,
      meta:{requireAuth:true, title:'订单详情-OMS'},
    },
    {
      path: '/orders/diy-create',
      name: 'DiyCreate',
      component: DiyCreate,
      meta:{requireAuth:true, title:'DIY作品-OMS'},
    },
    {
      path: '/orders/order-create',
      name: 'OrderCreate',
      component: OrderCreate,
      meta:{requireAuth:true, title:'订单图库-OMS'},
    },
    {
      path: '/orders/submit',
      name: 'OrderSubmit',
      component: OrderSubmit,
      meta:{requireAuth:true, title:'定制提交-OMS'},
    },
    {
      path: '/orders/cart',
      name: 'OrdersCart',
      component: OrdersCart,
      meta:{requireAuth:true, title:'定制提交-OMS'},
    },
    {
      path: '/orders/abandoned',
      name: 'OrdersAbandoned',
      component: OrdersAbandoned,
      meta:{requireAuth:true, title:'定制提交-OMS'},
    },
    {
      path: '/orders/upload-files',
      name: 'UploadFiles',
      component: UploadFiles,
      meta:{requireAuth:true, title:'图库-OMS'},
    },
    {
      path: '/returns',
      name: 'Returns',
      component: Returns,
      meta:{requireAuth:true, title:'退货-OMS'},
    },
    {
      path: '/email',
      name: 'email',
      component: Email,
      meta:{requireAuth:true, title:'Email-OMS'},
    },
    {
      path: '/email/templates',
      name: 'EmailTemplates',
      component: EmailTemplates,
      meta:{requireAuth:true, title:'EmailTemplates-OMS'},
    },
    {
      path: '/email/detail',
      name: 'EmailDetail',
      component: EmailDetail,
      meta:{requireAuth:true, title:'EmailDetail-OMS'},
    },
    {
      path: '/logistics',
      name: 'LogisticsIndex',
      component: LogisticsIndex,
      meta:{requireAuth:true, title:'物流包裹-OMS'},
    },
    {
      path: '/logistics-label',
      name: 'LogisticsLabel',
      component: LogisticsLabel,
      meta:{requireAuth:true, title:'面单打印-OMS'},
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      meta:{requireAuth:true, title:'活动-OMS'},
    },
    {
      path: '/refund',
      name: 'Refund',
      component: Refund,
      meta:{requireAuth:true, title:'退款-OMS'},
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta:{requireAuth:true, title:'用户-OMS'},
    },
    {
      path: '/users/detail',
      name: 'Usersdetail',
      component: Usersdetail,
      meta:{requireAuth:true, title:'详情-OMS'},
    },
    {
      path: '/sign',
      name: 'Sign',
      component: Sign,
      meta:{requireAuth:false, title:'登录-OMS'},
    },
    {
      path: '/setting',
      name: 'SettingIndex',
      component: SettingIndex,
      meta:{requireAuth:true, title:'设置-OMS'},
    },




  ],
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next({
        path: '/sign',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})
router.afterEach(function (to, from) {
  if(to.meta.title){
      document.title = to.meta.title;
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js